// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-avatar {
  width: 30px;
  height: 30px;
  margin: 10px;
}

.top_chunk {
  padding: 20px;
  box-sizing: border-box;
  background: #fff3e5;
}
.top_chunk .inline_chunker {
  display: inline-flex;
  grid-gap: 20px;
  width: 100%;
}
.top_chunk .inline_chunker img {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  height: 100px;
  min-height: 100px;
  max-height: 100px;
  object-fit: cover;
  border-radius: 10px;
  margin-top: -5px;
  border: 2px solid rgba(151, 126, 112, 0.5098039216);
  box-shadow: 0 5px 13px 0px #c5c5c5;
}
.top_chunk .grid_trigger_buttons {
  margin-left: 5px;
  width: 50%;
  float: right;
}
.top_chunk .grid_trigger_buttons ion-button {
  font-size: 12px;
  border-radius: 4px;
  width: -moz-fit-content;
  width: fit-content;
  border: 1px solid #e9995c;
  font-weight: bold;
  text-transform: uppercase;
  margin-left: auto;
  padding: 0 10px;
}
.top_chunk .grid_trigger_buttons ion-button ion-icon {
  color: #e9995c;
}
.top_chunk .profile_row {
  display: inline-flex;
}
.top_chunk .profile_row ion-avatar {
  margin-right: 15px;
}
.top_chunk .profile_row .badge {
  color: #fff;
  padding: 4px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 4px;
  font-size: 10px;
  margin-right: 2px;
  display: inline-block;
}
.top_chunk .profile_row .badge ion-icon {
  color: #fff;
}
.top_chunk .profile_row .staff_badge {
  background: #c4cce0;
}
.top_chunk .profile_row .star_badge {
  background: #ffdb94;
}
.top_chunk .profile_row h3 {
  margin: 0;
  font-size: 12px;
  margin-bottom: 3px;
  width: -moz-fit-content;
  width: fit-content;
}
.top_chunk .profile_row h4 {
  margin: 0;
  font-size: 21px;
}
.top_chunk .profile_row .custom_url {
  display: block;
  font-size: 10px;
  margin-bottom: 10px;
  margin-top: 5px;
}
.top_chunk .profile_row .stars {
  font-size: 12px;
  display: inline-flex;
  grid-gap: 4px;
}
.top_chunk .profile_row .stars ion-icon {
  font-size: 14px;
}
.top_chunk .sec_info {
  font-size: 12px;
  text-transform: uppercase;
  color: #8e8e8e;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 5px;
  display: inline-flex;
  flex-wrap: wrap;
  grid-gap: 10px;
}
.top_chunk .sec_info div {
  display: inline-flex;
  grid-gap: 5px;
}
.top_chunk .sec_info ion-icon {
  font-size: 14px;
  margin-top: 5px;
  color: #dbb49f;
}
.top_chunk .sec_info label {
  margin-top: 5px;
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 900;
}
.top_chunk .sec_info .url {
  font-weight: 400;
  text-transform: none;
}
.top_chunk .bio {
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  max-height: 60px;
  overflow: scroll;
}
.top_chunk .social_row {
  display: inline-flex;
  justify-content: space-evenly;
  text-align: left;
  width: 100%;
  margin-top: 10px;
  margin-left: 10px;
  grid-gap: 4px;
}
.top_chunk .social_row div {
  cursor: pointer;
}
.top_chunk .social_row label {
  display: block;
  font-size: 10px;
}
.top_chunk .social_row .follow_btn {
  border: 2px solid #ac8875;
  border-bottom-width: 4px;
  background: none;
  padding: 8px 15px;
  width: 100%;
  color: #ac8875;
  letter-spacing: 2px;
  font-weight: 900;
  text-transform: uppercase;
  font-size: 10px;
  margin-top: 2px;
  border-radius: 3px;
}
.top_chunk .social_row div:first-child {
  margin-right: 5px;
}
.top_chunk .social_row .dark {
  color: #fff;
  background: #ac8875;
}
.top_chunk .social_row .forceRight {
  margin-left: 40px;
}
.top_chunk .social_row .mail_btn {
  border: 2px solid #ac8875;
  border-bottom-width: 4px;
  background: none;
  color: #ac8875;
  padding: 4px 12px;
  font-size: 21px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/profile-detail-chunk/profile-detail-chunk.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AACI;EACI,oBAAA;EACA,cAAA;EACA,WAAA;AACR;AACQ;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EAEA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mDAAA;EACA,kCAAA;AAAZ;AAII;EACI,gBAAA;EACA,UAAA;EACA,YAAA;AAFR;AAIQ;EACI,eAAA;EACA,kBAAA;EAEA,uBAAA;EAAA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AAHZ;AAKY;EACI,cAAA;AAHhB;AAQI;EACI,oBAAA;AANR;AAQQ;EACI,kBAAA;AANZ;AASQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAPZ;AASY;EACI,WAAA;AAPhB;AAWQ;EACI,mBAAA;AATZ;AAYQ;EACI,mBAAA;AAVZ;AAaQ;EACI,SAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;AAXZ;AAcQ;EACI,SAAA;EACA,eAAA;AAZZ;AAeQ;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAbZ;AAgBQ;EACI,eAAA;EACA,oBAAA;EACA,aAAA;AAdZ;AAgBY;EACI,eAAA;AAdhB;AAmBI;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,oBAAA;EACA,eAAA;EACA,cAAA;AAnBR;AAqBQ;EACI,oBAAA;EACA,aAAA;AAnBZ;AAsBQ;EACI,eAAA;EACA,eAAA;EACA,cAAA;AApBZ;AAuBQ;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AArBZ;AAwBQ;EACI,gBAAA;EACA,oBAAA;AAtBZ;AA0BI;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAxBR;AA0BI;EACI,oBAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EAEA,aAAA;AAzBR;AA2BQ;EACI,eAAA;AAzBZ;AA4BQ;EACI,cAAA;EACA,eAAA;AA1BZ;AA6BQ;EACI,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EAEA,eAAA;EACA,kBAAA;AA5BZ;AA+BQ;EACI,iBAAA;AA7BZ;AAgCQ;EACI,WAAA;EACA,mBAAA;AA9BZ;AAiCQ;EACI,iBAAA;AA/BZ;AAkCQ;EACI,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAhCZ","sourcesContent":["ion-avatar {\n    width: 30px;\n    height: 30px;\n    margin: 10px;\n}\n\n.top_chunk {\n    padding: 20px;\n    box-sizing: border-box;\n    background: #fff3e5;\n\n    .inline_chunker {\n        display: inline-flex;\n        grid-gap: 20px;\n        width: 100%;\n\n        img {\n            width: 100px;\n            min-width: 100px;\n            max-width: 100px;\n            height: 100px;\n            min-height: 100px;\n            max-height: 100px;\n\n            object-fit: cover;\n            border-radius: 10px;\n            margin-top: -5px;\n            border: 2px solid #977e7082;\n            box-shadow: 0 5px 13px 0px #c5c5c5;\n        }\n    }\n\n    .grid_trigger_buttons {\n        margin-left: 5px;\n        width: 50%;\n        float: right;\n\n        ion-button {\n            font-size: 12px;\n            border-radius: 4px;\n\n            width: fit-content;\n            border: 1px solid #e9995c;\n            font-weight: bold;\n            text-transform: uppercase;\n            margin-left: auto;\n            padding: 0 10px;\n\n            ion-icon {\n                color: #e9995c;\n            }\n        }\n    }\n\n    .profile_row {\n        display: inline-flex;\n\n        ion-avatar {\n            margin-right: 15px;\n        }\n\n        .badge {\n            color: #fff;\n            padding: 4px;\n            padding-left: 8px;\n            padding-right: 8px;\n            border-radius: 4px;\n            font-size: 10px;\n            margin-right: 2px;\n            display: inline-block;\n\n            ion-icon {\n                color: #fff;\n            }\n        }\n\n        .staff_badge {\n            background: #c4cce0;\n        }\n\n        .star_badge {\n            background: #ffdb94;\n        }\n\n        h3 {\n            margin: 0;\n            font-size: 12px;\n            margin-bottom: 3px;\n            width: fit-content;\n        }\n\n        h4 {\n            margin: 0;\n            font-size: 21px;\n        }\n\n        .custom_url {\n            display: block;\n            font-size: 10px;\n            margin-bottom: 10px;\n            margin-top: 5px;\n        }\n\n        .stars {\n            font-size: 12px;\n            display: inline-flex;\n            grid-gap: 4px;\n\n            ion-icon {\n                font-size: 14px;\n            }\n        }\n    }\n\n    .sec_info {\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #8e8e8e;\n\n        margin-top: 10px;\n        margin-bottom: 10px;\n        line-height: 5px;\n\n        display: inline-flex;\n        flex-wrap: wrap;\n        grid-gap: 10px;\n\n        div {\n            display: inline-flex;\n            grid-gap: 5px;\n        }\n\n        ion-icon {\n            font-size: 14px;\n            margin-top: 5px;\n            color: #dbb49f;\n        }\n\n        label {\n            margin-top: 5px;\n            max-width: 200px;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            white-space: nowrap;\n            font-weight: 900;\n        }\n\n        .url {\n            font-weight: 400;\n            text-transform: none;\n        }\n    }\n\n    .bio {\n        margin-top: 10px;\n        margin-bottom: 20px;\n        width: 100%;\n        max-height: 60px;\n        overflow: scroll;\n    }\n    .social_row {\n        display: inline-flex;\n        justify-content: space-evenly;\n        text-align: left;\n        width: 100%;\n        margin-top: 10px;\n        margin-left: 10px;\n\n        grid-gap: 4px;\n\n        div {\n            cursor: pointer;\n        }\n\n        label {\n            display: block;\n            font-size: 10px;\n        }\n\n        .follow_btn {\n            border: 2px solid #ac8875;\n            border-bottom-width: 4px;\n            background: none;\n            padding: 8px 15px;\n            width: 100%;\n            color: #ac8875;\n            letter-spacing: 2px;\n            font-weight: 900;\n            text-transform: uppercase;\n            font-size: 10px;\n            //margin-left: 5%;\n            margin-top: 2px;\n            border-radius: 3px;\n        }\n\n        div:first-child {\n            margin-right: 5px;\n        }\n\n        .dark {\n            color: #fff;\n            background: #ac8875;\n        }\n\n        .forceRight {\n            margin-left: 40px;\n        }\n\n        .mail_btn {\n            border: 2px solid #ac8875;\n            border-bottom-width: 4px;\n            background: none;\n            color: #ac8875;\n            padding: 4px 12px;\n            font-size: 21px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
